/*
    Define "rows"
    Define $refs.tbody
*/

const handles_active_row = {
    mounted () {
        document.body.addEventListener("click", this.maybe_activate_row, { passive: false, capture: false })
    },
    beforeDestroy () {
        document.body.removeEventListener("click", this.maybe_activate_row, false)
    },
    methods: {
        container_for_active_row (row) {
            return row.closest("tbody")
        },
        maybe_activate_row (event) {
            if(!!this.active_rows_container && !!event.target && !!event.target.tagName.match(/^(input|select|textarea)$/i)) {
                const row = event.target.closest("tr")
                if(row) {
                    const container = this.container_for_active_row(row)
                    if(container && (container === this.active_rows_container)) {
                        this.activate_row(row)
                        return
                    }
                }
            }
            this.activate_row(null)
        },
        activate_row (row) {
            this.$emit("active_row_changed", row)
        }
    },
    computed: {
        active_rows_container () {
            return this.$refs.tbody
        }
    }
}

export default handles_active_row
